import React from 'react'
import {
    Box,
    Button,
    FormControlLabel,
    Grid,
    Link,
    Switch,
    Typography,
} from "@mui/material";
import { display } from '@mui/system';

export default function AgreeToTerms() {
    return (
        <Grid
            display="flex"
            gap={5}
            flexDirection="column"
            p={{ xs: 2, md: 5 }}
            mt={{ xs: 3, md: 0 }}

        >
            <Grid item xs={12} sm={6} display="flex" gap={1} flexDirection="column">
                <label htmlFor="agreeToTerms" style={styleSheet.labelText}>
                    Please agree to terms to publish your content
                </label>
                <Box
                    border={"1px solid #BFBFBF"}
                    borderRadius="10px"
                    height="509px"
                    display="flex"
                    gap={1}
                    p={2}
                >
                    <Box className="custom-scrollbar" sx={{ maxHeight: '500px', overflowY: 'scroll', padding: '16px' }}>
                        <Box sx={styleSheet.textContainer}>

                            <Typography sx={styleSheet.text}>
                                Pizza ipsum dolor meat lovers buffalo. Platter ipsum pepperoni burnt green pizza bell. Ham bell platter buffalo anchovies rib. String tomatoes peppers style peppers banana NY sauce. Roll sauce anchovies sauce personal Aussie.    </Typography>
                            <Typography sx={styleSheet.text}>
                                Green stuffed bell peppers hand meatball ham crust mayo. Dolor olives ricotta Bianca red red. Personal mouth mushrooms and pork platter deep ham ricotta ranch. Rib tomatoes roll ipsum thin. Stuffed ranch onions lot red personal. Pesto mayo style Chicago lot. Ranch ranch lot lasagna ham. Onions extra beef fresh ricotta ranch ipsum steak pizza. Green mozzarella buffalo lovers marinara marinara. Beef mouth lasagna mayo Philly burnt wing fresh.    </Typography>
                            <Box>
                                <Typography sx={styleSheet.text}>
                                    Spinach red bbq lot personal personal. Lasagna Chicago chicken pineapple pineapple pan bacon sautéed style mushrooms. Lot sautéed mozzarella crust wing rib tossed mushrooms hand sauce. Hawaiian mayo anchovies chicken fresh ham fresh chicken. And NY meatball black ham steak style dolor. Dolor platter bacon lovers mushrooms wing bacon. Pepperoni pesto banana wing style string. Pineapple and string roll anchovies. Bacon stuffed crust sausage platter Philly. Buffalo red anchovies wing meat mozzarella roll style pineapple tomato. Red bacon pepperoni NY spinach deep onions pepperoni extra. Onions parmesan garlic Philly beef Chicago olives steak.        </Typography>
                                <Typography sx={styleSheet.text}>
                                    Meat personal Philly lot tomatoes thin chicken rib anchovies. Anchovies large chicken thin dolor and marinara Aussie. Pie pepperoni roll ham pepperoni pepperoni steak. Wing bacon Chicago meatball lot NY pork platter burnt. Pie lasagna NY and Philly. Spinach Chicago string pan pie pan pesto crust pizza.        </Typography>
                            </Box>
                            <Box>
                                <Typography sx={styleSheet.text}>
                                    move follower. Auto arrow boolean main bullet thumbnail. Draft editor device select auto stroke union layer team style.
                                </Typography>
                                <Typography sx={styleSheet.text}>
                                    Polygon arrow font line figjam background layer variant. Rectangle hand mask figma object frame arrow style image.
                                </Typography>
                            </Box>

                        </Box>
                    </Box>
                </Box>
            </Grid>
        </Grid>
    )
}

const styleSheet = {
    mainContainer: {
        p: { xs: 2, sm: 3, md: 5 },
        width: { xs: "100%", sm: "90%", md: "802px" },
        margin: "auto",
    },
    container: {
        margin: 'auto',
        padding: { xs: '20px', sm: '30px', md: '40px' },
        border: '1px solid #ccc',
        borderRadius: '15px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 10px rgba(0,0,0,0.1)'
    },
    boxContainer: {
        display: 'flex',
        gap: { xs: 2, md: 5 },
        marginBottom: '16px',
        borderRadius: '8px 8px 0 0',
        flexDirection: { xs: 'column', md: 'row' },
    },
    btnPsychotherapy: {
        bgcolor: "#233F91",
        color: "#EDEDED",
        borderRadius: '15px',
        fontSize: { xs: '11px', sm: '14px' },
        fontWeight: 700,
        width: { xs: '90px', md: '106.81px' },
        padding: "7.96px, 9.4px, 7.96px, 9.4px",
        height: { xs: '20px', md: '20px' },
    },
    textContainer: {
        display: "flex",
        flexDirection: "column",
        gap: 1,

        // mt: 2,
    },
    text: {
        fontWeight: 500,
        fontSize: { xs: 17, sm: 18 },
        lineHeight: "24px",
        color: '#000000',
        spaceLetter: '-1%',
        width: "738px"

    },
    btnPurchase: {
        bgcolor: "#233F91",
        color: "#fff",
        borderRadius: '15px',
        fontSize: { xs: '14px', sm: '16px' },
        fontWeight: 700,
        width: { xs: '100%', sm: '90%', md: '466px' },
        height: '48px',
    },
    labelText: {
        fontWeight: 400,
        fontSize: "17px",
        color: "#000000",
    },
}